export default {
  setChats(state, payload) {
    state.chats = payload;
  },
  set_lastPage(state, payload) {
    state.paginations.last_page = payload;
  },
};
